import HealthGraphContainer from './HealthGraphContainer'

export default HealthGraphContainer